export default {"src":"/_next/static/media/editor_choice.7d355dc8.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};